module.exports = __webpack_public_path__ + "img/0S6A9560.04a20fcd.jpg";